import styled from 'styled-components';

export type ContentColumnPadding = 'default' | 'no-top' | 'none';

const paddingByVariant: Record<
  ContentColumnPadding,
  { mobile: string; desktop: string }
> = {
  default: { mobile: '8px', desktop: '32px 32px 0 32px' },
  'no-top': { mobile: '0 8px 8px 8px', desktop: '0 32px 0 32px' },
  none: { mobile: '0', desktop: '0' },
};

export const ContentColumn = styled.div<{
  isMobile: boolean;
  padding?: ContentColumnPadding;
  isChapter?: boolean;
  hasAccessibilityIcon?: boolean;
}>`
  position: relative;
  max-width: 1000px;
  margin: 0 auto;
  width: 100%;
  padding: ${({ isMobile, padding = 'default' }) =>
    isMobile
      ? paddingByVariant[padding].mobile
      : paddingByVariant[padding].desktop};
  ${({ hasAccessibilityIcon }) =>
    hasAccessibilityIcon &&
    'padding-top: calc(var(--xlarge-padding) + var(--default-padding));'}
  ${({ isChapter }) =>
    isChapter &&
    `
    height: 100%;
    flex: 1;
  `}
`;
